'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propEnhancers = exports.propValidators = exports.propAliases = exports.propTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getCss = require('../get-css');

var _getCss2 = _interopRequireDefault(_getCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = exports.propTypes = {
  alignContent: _propTypes2.default.string,
  alignItems: _propTypes2.default.string,
  alignSelf: _propTypes2.default.string,
  flex: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  flexBasis: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  flexDirection: _propTypes2.default.string,
  flexFlow: _propTypes2.default.string,
  flexGrow: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  flexShrink: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  flexWrap: _propTypes2.default.string,
  justifyContent: _propTypes2.default.string,
  justifyItems: _propTypes2.default.string,
  justifySelf: _propTypes2.default.string,
  order: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  placeContent: _propTypes2.default.string,
  placeItems: _propTypes2.default.string,
  placeSelf: _propTypes2.default.string
};

var propAliases = exports.propAliases = {};

var propValidators = exports.propValidators = {};

var _flex = {
  className: 'flx',
  cssName: 'flex',
  jsName: 'flex',
  isPrefixed: true,
  defaultUnit: ''
};
var _alignItems = {
  className: 'algn-itms',
  cssName: 'align-items',
  jsName: 'alignItems',
  isPrefixed: true
};
var _alignSelf = {
  className: 'algn-slf',
  cssName: 'align-self',
  jsName: 'alignSelf',
  isPrefixed: true
};
var _alignContent = {
  className: 'algn-cnt',
  cssName: 'align-content',
  jsName: 'alignContent',
  isPrefixed: true
};
var _justifyContent = {
  className: 'just-cnt',
  cssName: 'justify-content',
  jsName: 'justifyContent',
  isPrefixed: true
};
var _justifyItems = {
  className: 'just-items',
  cssName: 'justify-items',
  jsName: 'justifyItems',
  isPrefixed: true
};
var _justifySelf = {
  className: 'just-self',
  cssName: 'justify-self',
  jsName: 'justifySelf',
  isPrefixed: true
};
var _flexDirection = {
  className: 'flx-drct',
  cssName: 'flex-direction',
  jsName: 'flexDirection',
  isPrefixed: true,
  safeValue: true
};
var _flexWrap = {
  className: 'flx-wrap',
  cssName: 'flex-wrap',
  jsName: 'flexWrap',
  isPrefixed: true,
  safeValue: true
};
var _flexGrow = {
  className: 'flx-grow',
  cssName: 'flex-grow',
  jsName: 'flexGrow',
  isPrefixed: true,
  defaultUnit: ''
};
var _flexShrink = {
  className: 'flx-srnk',
  cssName: 'flex-shrink',
  jsName: 'flexShrink',
  isPrefixed: true,
  defaultUnit: ''
};
var _flexBasis = {
  className: 'flx-basis',
  cssName: 'flex-basis',
  jsName: 'flexBasis',
  isPrefixed: true
};
var _order = {
  className: 'order',
  cssName: 'order',
  jsName: 'order',
  isPrefixed: true,
  defaultUnit: '',
  safeValue: true
};
var _flexFlow = {
  className: 'flx-flow',
  cssName: 'flex-flow',
  jsName: 'flexFlow',
  isPrefixed: true,
  defaultUnit: ''
};
var _placeContent = {
  className: 'plc-cnt',
  cssName: 'place-content',
  jsName: 'placeContent'
};
var _placeItems = {
  className: 'plc-items',
  cssName: 'place-items',
  jsName: 'placeItems'
};
var _placeSelf = {
  className: 'plc-self',
  cssName: 'place-self',
  jsName: 'placeSelf'
};

var propEnhancers = exports.propEnhancers = {
  alignContent: function alignContent(value) {
    return (0, _getCss2.default)(_alignContent, value);
  },
  alignItems: function alignItems(value) {
    return (0, _getCss2.default)(_alignItems, value);
  },
  alignSelf: function alignSelf(value) {
    return (0, _getCss2.default)(_alignSelf, value);
  },
  flex: function flex(value) {
    return (0, _getCss2.default)(_flex, value);
  },
  flexBasis: function flexBasis(value) {
    return (0, _getCss2.default)(_flexBasis, value);
  },
  flexDirection: function flexDirection(value) {
    return (0, _getCss2.default)(_flexDirection, value);
  },
  flexFlow: function flexFlow(value) {
    return (0, _getCss2.default)(_flexFlow, value);
  },
  flexGrow: function flexGrow(value) {
    return (0, _getCss2.default)(_flexGrow, value);
  },
  flexShrink: function flexShrink(value) {
    return (0, _getCss2.default)(_flexShrink, value);
  },
  flexWrap: function flexWrap(value) {
    return (0, _getCss2.default)(_flexWrap, value);
  },
  justifyContent: function justifyContent(value) {
    return (0, _getCss2.default)(_justifyContent, value);
  },
  justifyItems: function justifyItems(value) {
    return (0, _getCss2.default)(_justifyItems, value);
  },
  justifySelf: function justifySelf(value) {
    return (0, _getCss2.default)(_justifySelf, value);
  },
  order: function order(value) {
    return (0, _getCss2.default)(_order, value);
  },
  placeContent: function placeContent(value) {
    return (0, _getCss2.default)(_placeContent, value);
  },
  placeItems: function placeItems(value) {
    return (0, _getCss2.default)(_placeItems, value);
  },
  placeSelf: function placeSelf(value) {
    return (0, _getCss2.default)(_placeSelf, value);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/ui-box/lib/enhancers/flex.js
// module id = 335
// module chunks = 0